import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

// Get all animation block sections.
const animatedSections = document.querySelectorAll('[data-animation-id]');

// Get height and width of window for default slideIn settings.
const width =
  window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

const height =
  window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

// Helper.
function isInViewport(element) {
  const rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

/* eslint-disable-next-line complexity */
animatedSections.forEach((animatedSection) => {
  const { animationId } = animatedSection.dataset;
  const animateSettings = window[animationId];

  const {
    type,
    scrub,
    duration,
    delay,
    direction,
    distance,
    trigger,
    viewportPercent,
    animateWhenVisible,
  } = animateSettings;

  if (!animateWhenVisible && isInViewport(animatedSection)) {
    return;
  }

  let horizontal = 0;
  let vertical = 0;

  if (type === 'slideIn') {
    switch (direction) {
      case 'left':
        horizontal = -width;
        break;
      case 'right':
        horizontal = width;
        break;
      case 'up':
        vertical = -height;
        break;
      case 'down':
        vertical = height;
        break;
      default:
        break;
    }
  }

  if (type === 'slideInFade') {
    switch (direction) {
      case 'left':
        horizontal = `${-distance}px`;
        break;
      case 'right':
        horizontal = `${distance}px`;
        break;
      case 'up':
        vertical = `${-distance}px`;
        break;
      case 'down':
        vertical = `${distance}px`;
        break;
      default:
        break;
    }
  }

  const gsapArgs = {
    // Timing (timing & delay).
    duration,
    delay,

    // slideIn.
    x: horizontal ?? 0,
    y: vertical ?? 0,

    // fadeIn.
    opacity: type === 'fadeIn' || type === 'slideInFade' ? 0 : 1,
  };

  if (trigger === 'viewport') {
    gsapArgs.scrollTrigger = {
      trigger: `[data-animation-id="${animationId}"]`,
      toggleActions: 'play none none none',
      start: `${viewportPercent}% bottom`,
      scrub,
    };
  }

  gsap.from(`[data-animation-id="${animationId}"]`, gsapArgs);
});
